export default function useUserAccounts(userData) {
    const getSettingByName = (name, defaultValue = "") => {
        if (!userData.settings) {
            userData.settings = [];
        }

        let setting = userData.settings.find((setting) => setting.name === name);
        if (!setting) {
            setting = {
                name: name,
                userId: userData.id,
                value: defaultValue,
            };
            userData.settings.push(setting);
        }
        return setting;
    };

    return {
        getSettingByName,
    };
}
